module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-144x144-e94ba1adbf81b67eb593b36962bd1e2f.png";